import { logger } from '#pplx/frontend/logger/browser.js';
export function getEppoOverride({ flag, override, defaultValue, isServer = false, }) {
    if (!override) {
        return {
            shouldUseOverride: false,
            value: null,
        };
    }
    try {
        // Cast based on the expected type
        if (typeof defaultValue === 'boolean') {
            return {
                shouldUseOverride: true,
                value: (override === 'true'),
            };
        }
        else if (typeof defaultValue === 'number') {
            return {
                shouldUseOverride: true,
                value: Number(override),
            };
        }
        else if (typeof defaultValue === 'object') {
            try {
                return {
                    shouldUseOverride: true,
                    value: JSON.parse(override),
                };
            }
            catch (err) {
                logger.warn(`[Eppo ${isServer ? 'Server ' : ''}Override]`, `Failed to parse JSON override for flag "${flag}"`, { override, error: err });
                return {
                    shouldUseOverride: true,
                    value: defaultValue,
                };
            }
        }
        // For string or other types
        return {
            shouldUseOverride: true,
            value: override,
        };
    }
    catch (error) {
        logger.debug(`[Eppo ${isServer ? 'Server ' : ''}Override] Error:`, error);
        return {
            shouldUseOverride: true,
            value: defaultValue,
        };
    }
}
//# sourceMappingURL=getEppoOverride.js.map